import * as tslib_1 from "tslib";
import { createSelector } from '@ngrx/store';
import { createEntityAdapter } from '@ngrx/entity';
import * as pusher from 'store/actions/pusher.actions';
var ɵ0 = function (search) {
    return search.generateReport + "-" + search.customerId + "-" + search.id + "-" + search.engineType;
};
export var searchAdapter = createEntityAdapter({
    selectId: ɵ0
});
export var customerAdapter = createEntityAdapter();
var ɵ1 = function (search) {
    return search.id + "-" + search.engineType;
};
export var quickscanSearchAdapter = createEntityAdapter({
    selectId: ɵ1
});
export var quickscanAdapter = createEntityAdapter();
var ɵ2 = function (nlp) {
    return nlp.customerId + "-" + nlp.recordId;
};
export var nlpAdapter = createEntityAdapter({
    selectId: ɵ2
});
var ɵ3 = function (quickscanNlp) {
    return "" + quickscanNlp.id;
};
export var quickscanNlpAdapter = createEntityAdapter({
    selectId: ɵ3
});
var initialState = {
    searches: searchAdapter.getInitialState(),
    customers: customerAdapter.getInitialState(),
    quickscans: quickscanAdapter.getInitialState(),
    quickscanSearches: quickscanSearchAdapter.getInitialState(),
    nlp: nlpAdapter.getInitialState(),
    quickscanNlp: quickscanNlpAdapter.getInitialState()
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case pusher.PusherActionTypes.REMOVE_CUSTOMER: {
            var customerIds = action.payload;
            var updates = customerIds.map(function (customerId) {
                return {
                    id: customerId,
                    changes: {
                        isRemoved: true
                    }
                };
            });
            return tslib_1.__assign({}, state, { customers: customerAdapter.updateMany(updates, state.customers) });
        }
        case pusher.PusherActionTypes.CLEAR_CUSTOMER: {
            return tslib_1.__assign({}, state, { searches: searchAdapter.removeMany(function (i) {
                    var ids = action.payload;
                    return ids.indexOf(i.customerId) >= 0;
                }, state.searches), customers: customerAdapter.removeMany(action.payload, state.customers) });
        }
        case pusher.PusherActionTypes.SET_SCREENING: {
            var _a = action.payload, customer = _a.customer, search = _a.search;
            return tslib_1.__assign({}, state, { searches: searchAdapter.upsertOne(tslib_1.__assign({}, search, { isRemoved: false }), state.searches), customers: customerAdapter.upsertOne(tslib_1.__assign({}, customer, { isRemoved: false }), state.customers) });
        }
        case pusher.PusherActionTypes.REMOVE_SCREENING: {
            var _b = action.payload, customerId = _b.customerId, id = _b.id, engineType = _b.engineType, generateReport = _b.generateReport, error = _b.error;
            var newState = searchAdapter.updateOne({
                id: generateReport + "-" + customerId + "-" + id + "-" + engineType,
                changes: {
                    isRemoved: true,
                    error: error
                }
            }, state.searches);
            var newCustomerState = state.customers;
            return tslib_1.__assign({}, state, { customers: newCustomerState, searches: newState });
        }
        case pusher.PusherActionTypes.REMOVE_QUICKSCAN: {
            return tslib_1.__assign({}, state, { quickscanSearches: quickscanSearchAdapter.removeMany(function (i) {
                    var ids = action.payload;
                    return ids.indexOf(i.id) >= 0;
                }, state.quickscanSearches), quickscans: quickscanAdapter.removeMany(action.payload, state.quickscans) });
        }
        case pusher.PusherActionTypes.SET_QUICKSCAN_SEARCH: {
            var _c = action.payload, quickscan = _c.quickscan, search = _c.search;
            return tslib_1.__assign({}, state, { quickscanSearches: quickscanSearchAdapter.upsertOne(tslib_1.__assign({}, search, { isRemoved: false }), state.quickscanSearches), quickscans: quickscanAdapter.upsertOne(quickscan, state.quickscans) });
        }
        case pusher.PusherActionTypes.REMOVE_QUICKSCAN_SEARCH: {
            var _d = action.payload, engineType = _d.engineType, id = _d.id;
            var newState = quickscanSearchAdapter.updateOne({
                id: id + "-" + engineType,
                changes: {
                    isRemoved: true
                }
            }, state.quickscanSearches);
            var newQuickscanState = state.quickscans;
            return tslib_1.__assign({}, state, { quickscans: newQuickscanState, quickscanSearches: newState });
        }
        case pusher.PusherActionTypes.SET_NLP: {
            var nlp = action.payload.nlp;
            return tslib_1.__assign({}, state, { nlp: nlpAdapter.upsertOne(tslib_1.__assign({}, nlp, { isRemoved: false }), state.nlp) });
        }
        case pusher.PusherActionTypes.REMOVE_NLP: {
            var _e = action.payload, customerId = _e.customerId, recordId = _e.recordId, error = _e.error;
            var newState = nlpAdapter.updateOne({
                id: customerId + "-" + recordId,
                changes: {
                    isRemoved: true,
                    error: error
                }
            }, state.nlp);
            return tslib_1.__assign({}, state, { nlp: newState });
        }
        case pusher.PusherActionTypes.SET_QUICKSCAN_NLP: {
            var quickscanNlp = action.payload.quickscanNlp;
            return tslib_1.__assign({}, state, { quickscanNlp: quickscanNlpAdapter.upsertOne(tslib_1.__assign({}, quickscanNlp, { isRemoved: false }), state.quickscanNlp) });
        }
        case pusher.PusherActionTypes.REMOVE_QUICKSCAN_NLP: {
            var id = action.payload.id;
            var newState = quickscanNlpAdapter.updateOne({
                id: "" + id,
                changes: {
                    isRemoved: true
                }
            }, state.quickscanNlp);
            return tslib_1.__assign({}, state, { quickscanNlp: newState });
        }
        default: {
            return state;
        }
    }
}
var pusherSelector = function (state) { return state.pusher; };
var ɵ4 = pusherSelector;
var ɵ5 = function (customerId, crps) { return createSelector(pusherSelector, function (state) {
    var groupByCrp = {};
    crps.forEach(function (crp) {
        var searches = state.searches.ids.filter(function (id) { return id.includes("-" + customerId + "-" + crp.record); });
        if (!searches || searches.length === 0) {
            groupByCrp[crp.record] = true;
        }
        else {
            var conclusion_1 = true;
            searches.forEach(function (searchId) {
                var entities = state.searches.entities[searchId];
                conclusion_1 = conclusion_1 && entities.isRemoved;
            });
            groupByCrp[crp.record] = conclusion_1;
        }
    });
    groupByCrp['all'] = true;
    var customer = state.customers.entities[customerId];
    if (!customer || !customer.screeningRequest.crpId) {
        Object.keys(groupByCrp).forEach(function (record) {
            groupByCrp['all'] = groupByCrp['all'] && groupByCrp[record];
        });
        if (customer && customer.isRemoved === false) {
            groupByCrp['all'] = false;
        }
    }
    if (customer && customer.screeningRequest.crpId) {
        groupByCrp[customer.screeningRequest.recordId] = false;
    }
    return groupByCrp;
}); }, ɵ6 = function (eventFilter) { return createSelector(pusherSelector, function (state) {
    var finishedCustomerList = [];
    state.customers.ids.forEach(function (customerId) {
        var searches = state.searches.ids.filter(function (id) { return id.startsWith(eventFilter + "-" + customerId + "-"); });
        // if the customer is not in store or in store but all searches are marked as removed
        if (!searches || (searches.length > 0 && !searches.some(function (id) { return !state.searches.entities[id].isRemoved; }))) {
            var customerPusher = Object.assign({}, state.customers.entities[customerId]);
            if (searches && searches.some(function (id) { return state.searches.entities[id].error; })) {
                customerPusher.error = true;
            }
            if (!customerPusher.isRemoved) {
                finishedCustomerList.push(customerPusher);
            }
        }
    });
    return finishedCustomerList;
}); }, ɵ7 = function (state) {
    var ids = [];
    state.quickscans.ids.forEach(function (quickscanId) {
        var searches = state.quickscanSearches.ids.filter(function (id) { return id.startsWith(quickscanId + "-"); });
        if (!searches
            || searches.length > 0
                && searches.filter(function (id) { return !state.quickscanSearches.entities[id].isRemoved; }).length === 0) {
            ids.push(state.quickscans.entities[quickscanId]);
        }
    });
    return ids;
}, ɵ8 = function (state) { return searchAdapter.getSelectors().selectAll(state.searches); }, ɵ9 = function (state) { return nlpAdapter.getSelectors().selectAll(state.nlp); }, ɵ10 = function (state) {
    return quickscanSearchAdapter.getSelectors().selectAll(state.quickscanSearches);
}, ɵ11 = function (state) {
    return quickscanNlpAdapter.getSelectors().selectAll(state.quickscanNlp);
};
export var Selectors = {
    finishCustomerSummary: ɵ5,
    finishCustomer: ɵ6,
    finishQuickscan: createSelector(pusherSelector, ɵ7),
    search: {
        selectAll: createSelector(pusherSelector, ɵ8)
    },
    customer: customerAdapter.getSelectors(),
    nlp: createSelector(pusherSelector, ɵ9),
    quickScanSearches: createSelector(pusherSelector, ɵ10),
    quickScanNlp: createSelector(pusherSelector, ɵ11),
};
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11 };
